
const KmFareModal = ({
    setShowKmModal,
    oneWayFare,
    setOneWayFare,
    isOneWayLoading,
    handleSaveOneWayFare
}) => {


    return (
        <div className="custom-modal-overlay">
            <div className="custom-modal">

                <div className="custom-modal-header">
                    <h4>Add Fare Configuration</h4>
                    <button
                        className="close-btn"
                        onClick={() => setShowKmModal(false)}
                    >
                        ×
                    </button>
                </div>

                <div className="custom-modal-body">
                    <div className="form-section">
                        <h6>Fare Settings</h6>
                        <div className="form flex align-center gap-3 flex-wrap">
                            <div className="form-group" key="incity">

                                <label>Incity ₹/km Charge</label>
                                <input
                                    type="number"
                                    name="incity"
                                    value={oneWayFare.incity}
                                    onChange={(e) => setOneWayFare({ ...oneWayFare, incity: e.target.value })}
                                />
                            </div>
                            <div className="form-group" key="incity">

                                <label>Outstation ₹/km Charge</label>
                                <input
                                    type="number"
                                    name="outstation"
                                    value={oneWayFare.outstation}
                                    onChange={(e) => setOneWayFare({ ...oneWayFare, outstation: e.target.value })}

                                />
                            </div>
                            <div className="form-group" key="incity">

                                <label>Mini Outstation ₹/km Charge</label>
                                <input
                                    type="number"
                                    name="miniOutStation"
                                    value={oneWayFare.minioutstation}
                                    onChange={(e) => setOneWayFare({ ...oneWayFare, minioutstation: e.target.value })}

                                />
                            </div>

                        </div>

                    </div>
                </div>

                <div className="custom-modal-footer">
                    <button className="btn btn-dark"
                        onClick={() => setShowKmModal(false)}>
                        Cancel
                    </button>

                    <button
                        className="btn btn-success"
                        onClick={handleSaveOneWayFare}
                        disabled={isOneWayLoading}>
                        {isOneWayLoading ? "saving...." : "Save Fare"}
                    </button>
                </div>

            </div>
        </div>
    );
};

export default KmFareModal;
